import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import config from '../app/config';

if (!config.azureAdTenantId) {
  throw new Error('msalConfig: REACT_APP_AZURE_AD_TENANT_ID is missing');
}
if (!config.azureAdClientId) {
  throw new Error('msalConfig: REACT_APP_AZURE_AD_CLIENT_ID is missing');
}

const msalConfig: Configuration = {
  auth: {
    clientId: config.azureAdClientId,
    authority: `https://login.microsoftonline.com/${config.azureAdTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: config.isDev ? LogLevel.Verbose : LogLevel.Warning,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) {
          console.log('[MSAL]', message);
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Default login scopes
export const loginRequest = {
  scopes: ['User.Read'],
};
